import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'PressNoteMd.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/views/PressRoomListing/PressNoteSm.intl.js